import { styled } from '@mui/material';
import { FeedbackSection, GeneralSection, GradingSection, StudentSection } from 'components/CreateAssignment';
import AssignmentImportSection from 'components/CreateAssignment/AssignmentImportSection';
import InlineCommentsSection from 'components/CreateAssignment/InlineCommentsSection';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Box, Button, Container, Icon, Stack, Text } from 'shell/components';

const Mobile = ({ batch, submissions, onClickBack, onClickSave, ...rest }) => {
    const location = useLocation();
    const { t } = useTranslation('assignment');

    const isEditable = !Boolean(submissions?.length) && !Boolean(batch?.length);

    return (
        <>
            <Container device={'mobile'}>
                <CustomStack alignItems={'flex-start'} spacing={5}>
                    <Button startIcon={<Icon kind={'arrowLeft'} />} variant={'borderless'} onClick={onClickBack}>
                        {t('common:controls.back', 'Back')}
                    </Button>
                    <Stack alignItems={'flex-start'} spacing={2}>
                        <Text component={'h1'} variant={'h6'}>
                            {location.pathname.endsWith('new')
                                ? t('create-assignment.create-title', 'Create an Assignment')
                                : t('create-assignment.edit-title', 'Edit an Assignment')}
                        </Text>
                        <Button
                            startIcon={<Icon kind={'video'} />}
                            variant={'borderless'}
                            onClick={() => rest.openVideoAssignmentCreation()}
                        >
                            {t(
                                'create-assignment.assignment-creation-walkthrough',
                                'Assignment Creation Walkthrough'
                            )}{' '}
                        </Button>
                        <Text>
                            {t(
                                'create-assignment.description',
                                'Provide details about your assignment to guide our AI in providing you with grading and/or feedback suggestions!'
                            )}
                        </Text>
                    </Stack>
                    {!isEditable && (
                        <CustomBox>
                            <CustomText>
                                {t(
                                    'create-assignment.edit-restriction-message',
                                    'Please note, editing assignment details after upload is restricted to ensure consistent grades/feedback for all students. If you need to make changes, duplicate the assignment and edit the new version.'
                                )}
                            </CustomText>
                        </CustomBox>
                    )}
                    <AssignmentImportSection disabled={!isEditable} onImport={rest.onClickImportAssignmentSettings} />
                    <GeneralSection isEditable={isEditable} {...rest} />
                    <GradingSection isEditable={isEditable} {...rest} />
                    <FeedbackSection isEditable={isEditable} {...rest} />
                    <StudentSection isEditable={isEditable} {...rest} />
                    <InlineCommentsSection isEditable={isEditable} {...rest} />
                </CustomStack>
            </Container>
        </>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(5),
    };
});

const CustomBox = styled(Box)(({ theme }) => {
    return {
        borderRadius: '8px',
        padding: theme.spacing(2, 3),
        background: theme.palette.ensightful.warning[100],
    };
});

const CustomText = styled(Text)(({ theme }) => {
    return {
        color: theme.palette.ensightful.warning[900],
    };
});

export default Mobile;
